var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPatientMarketingAttributeIcon = function SvgPatientMarketingAttributeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 63,
    viewBox: "0 0 57 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 12.6C26.7583 12.6 25.2674 11.9831 24.0271 10.7494C22.7868 9.51562 22.1667 8.0325 22.1667 6.3C22.1667 4.5675 22.7868 3.08437 24.0271 1.85063C25.2674 0.616875 26.7583 0 28.5 0C30.2417 0 31.7326 0.616875 32.9729 1.85063C34.2132 3.08437 34.8333 4.5675 34.8333 6.3C34.8333 8.0325 34.2132 9.51562 32.9729 10.7494C31.7326 11.9831 30.2417 12.6 28.5 12.6ZM19 63V22.05C15.8333 21.7875 12.6139 21.3937 9.34167 20.8687C6.06944 20.3438 2.95556 19.6875 0 18.9L1.58333 12.6C5.7 13.7025 10.0806 14.5031 14.725 15.0019C19.3694 15.5006 23.9611 15.75 28.5 15.75C33.0389 15.75 37.6306 15.5006 42.275 15.0019C46.9194 14.5031 51.3 13.7025 55.4167 12.6L57 18.9C54.0444 19.6875 50.9306 20.3438 47.6583 20.8687C44.3861 21.3937 41.1667 21.7875 38 22.05V63H31.6667V44.1H25.3333V63H19Z",
    fill: "#B864C6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPatientMarketingAttributeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/patient-marketing-attribute-icon.612f557a.svg";
export { ForwardRef as ReactComponent };